<template>
  <div>
    <Search v-model="search"></Search>
    <v-card :elevation="$root.ele" class="mt-4">
      <v-data-table
        :headers="headers"
        :footer-props="{
          'items-per-page-options': [10, 20, 50, -1]
        }"
        :items-per-page="50"
        class="templates-table"
        :search="search"
        :items="list"
      >
        <template v-slot:item.action="{ item }">
          <v-btn icon @click="$router.push(`/customers/${item.id}`)">
            <v-icon>
              mdi-pencil
            </v-icon>
          </v-btn>
        </template>
        <template v-slot:item.phone="{ item }">
          <a :href="`tel:${item.fields.Phone}`">
            {{ formatPhone(item.fields.Phone) }}
          </a>
        </template>
        <template v-slot:item.template="{ item }">
          {{ getTemplate(item) }}</template
        >
        <template v-slot:item.updated_by="{ item }">
          {{ updated(item) }}</template
        >
        <template v-slot:item.sms="{ item }">
          <span :style="{ color: SMScolor(item) }"> {{ formatSMS(item) }}</span>
        </template>
      </v-data-table>
      <v-divider></v-divider>
    </v-card>
  </div>
</template>
<script>
import types from "../../assets/js/types";
import Search from "./Search";
import smsList from "../../assets/js/sms_status";
import smsColor from "../../assets/js/sms_color";
import { formatPhone } from "../../assets/js/common";
smsColor;
export default {
  components: {
    Search
  },
  data() {
    return {
      lastDoc: null,
      types: types,
      search: "",
      id: ""
    };
  },
  computed: {
    headers() {
      let headers = [
        { text: "CREATE DATE", value: "created_at" },
        { text: "JOB NUMBER", value: "job_number" },
        { text: "NAME", value: "name" },
        { text: "PHONE", value: "phone" },
        { text: "TEMPLATE", value: "template" },
        { text: "Job Status", value: "status" },
        { text: "SMS STATUS", value: "sms" },
        { text: "UPDATED ON", value: "updated_at" },
        { text: "UPDATED BY", value: "updated_by" },
        { text: "ACTION", value: "action" }
      ];
      let list = [];
      for (let item of headers) {
        let { text, value } = item;
        let doc = {
          text,
          value,
          class: "text-capitalize",
          align: "start",
          sortable: true,
          divider: true,
          filterable: false
        };
        if (value === "sms") doc.width = "150px";
        if (value === "name") doc.filterable = true;
        if (value === "action") doc.divider = false;
        list.push(doc);
      }
      return list;
    },
    templates() {
      return this.$store.getters.templates;
    },
    list() {
      return this.$store.getters.customers;
    },
    users() {
      return this.$store.getters.users;
    }
  },
  methods: {
    formatPhone(phone) {
      return formatPhone(phone);
    },
    updated({ updated_by }) {
      let name = updated_by;
      this.users.forEach(item => {
        let { email, first_name, last_name } = item;
        if (email === updated_by) name = `${first_name} ${last_name}`;
      });
      return name;
    },
    sms({ sms_status }) {
      let i = 0;
      sms_status.forEach(({ status }) => {
        if (status === "d") i++;
      });
      let len = sms_status.length;
      let percent = (i * 100) / len;
      return Math.round(percent);
    },
    smsSend({ sms_status }) {
      let i = 0;
      sms_status.forEach(({ status }) => {
        if (status === "d") i++;
      });
      let l = sms_status.length;
      return `${i}/${l} sent`;
    },
    formatSMS({ sms }) {
      return smsList[sms];
    },
    SMScolor({ sms }) {
      return smsColor[sms];
    },
    getTemplate({ template }) {
      let name = "";
      const vm = this;
      vm.templates.forEach(item => {
        if (item.id === template) name = item.name;
      });
      return name;
    },
    type({ type }) {
      let name = "";
      this.types.forEach(item => {
        if (item.value === type) name = item.name;
      });
      return name;
    }
  }
};
</script>

<style lang="scss"></style>
